import { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";

export default function ScrollIndicator() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => {
      const scrollable = document.documentElement.scrollHeight > window.innerHeight + 100;
      const nearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 150;
      setVisible(scrollable && !nearBottom);
    };

    check();
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check, { passive: true });

    // Re-check after content loads
    const timer = setTimeout(check, 1000);

    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
      clearTimeout(timer);
    };
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollBy({ top: window.innerHeight * 0.7, behavior: "smooth" })}
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 flex flex-col items-center gap-0.5 opacity-60 hover:opacity-100 transition-opacity cursor-pointer"
      data-testid="scroll-indicator"
      aria-label="Scroll down for more"
    >
      <span className="text-[11px] text-muted-foreground font-medium tracking-wide bg-background/80 backdrop-blur-sm px-3 py-1 rounded-full border border-border shadow-sm">
        Scroll for more
      </span>
      <ChevronDown className="w-4 h-4 text-muted-foreground animate-bounce" />
    </button>
  );
}
